import React from "react"
import styled from "styled-components"
import { SectionHeading } from "../elements"
import {
  breakpointSmall,
  breakpointLarge,
  headerHeightMd,
  headerHeightLg,
  fontPrimary,
} from "../variables"

const PostFBFeed = () => {
  return (
    <FeedContainer>
      <div className="desktop-feed">
        <SectionHeading
          fontSize="15px"
          fontFamily={fontPrimary}
          margin="0 0 6px 0"
        >
          Facebook Updates
        </SectionHeading>
        <iframe
          title="facebook feed"
          name="facebook feed"
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmahipono%2F%20&tabs=timeline&width=340&height=1000&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
          height="1000"
          data-adapt-container-width="true"
          style={{ border: "none", overflow: "hidden" }}
          scrolling="no"
          frameBorder="0"
          allowtransparency="true"
          allow="encrypted-media"
        />
      </div>
    </FeedContainer>
  )
}

export default PostFBFeed

const FeedContainer = styled.div`
  .desktop-feed {
    display: none;
  }

  @media (min-width: ${breakpointSmall}) {
    .desktop-feed {
      display: block;
      width: 100%;
      position: sticky;
      top: ${`calc(${headerHeightMd} + 20px)`};

      iframe {
        width: 340px;
      }
    }
  }

  @media (min-width: ${breakpointLarge}) {
    .desktop-feed {
      top: ${`calc(${headerHeightLg} + 20px)`};
    }
  }
`
